import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { unsubscribe } from "@/graphql/mutations";

const client = generateClient();

export const unsubscribeSubsbcriptionsState = create<State<boolean>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const unsubscribeSubsbcriptionsIsloading = () =>
  unsubscribeSubsbcriptionsState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const unsubscribeSubsbcriptionsIsError = (error: Error) =>
  unsubscribeSubsbcriptionsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const unsubscribeSubsbcriptionsIsSuccess = (
  listInvoices: boolean
) =>
  unsubscribeSubsbcriptionsState.setState(() => ({
    data: listInvoices,
    isLoading: false,
    error: null,
  }));

export const resetUnsubscribeSubsbcriptionsState = () =>
  unsubscribeSubsbcriptionsState.setState(() => unsubscribeSubsbcriptionsState.getInitialState());

export const unsubscribeSubsbcriptions = async () => {
  unsubscribeSubsbcriptionsIsloading();

  try {
    const { data } = await client.graphql({
      query: unsubscribe,
    });

    unsubscribeSubsbcriptionsIsSuccess(data.unsubscribe as boolean);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to mutate unsubscription";
    unsubscribeSubsbcriptionsIsError(Error(errorMessage));
  }
};
